import React from 'react'

export const Relative = ({ children }) => {
  const style = {
    position: 'relative'
  }
  return <div style={style}>{children}</div>
}

export const Absolute = ({ children, top, bottom, left, right, maxWidth, maxHeight, zIndex }) => {
  const style = {
    position: 'absolute',
    top,
    bottom,
    left,
    right,
    maxWidth,
    maxHeight,
    zIndex
  }
  return <div style={style}>{children}</div>
}
